import React, { useState, useEffect } from 'react';
import { 
  CContainer, CHeader, CHeaderBrand, CHeaderNav, CNavItem, CNavLink, 
  CDropdown, CDropdownToggle, CDropdownMenu, CDropdownItem, CFormInput, 
  CButton, CHeaderToggler, CCollapse ,CRow,CCol 
} from '@coreui/react';

import CIcon from '@coreui/icons-react';
import { cilSearch, cilUser, cilMenu } from '@coreui/icons';
import { useNavigate, Outlet } from 'react-router-dom';
import logo from '../assets/images/logo.png';
import AnnouncementBanner from '../components/AnnouncementBanner';

const MembershipLayout = () => {
  const navigate = useNavigate();
  
  // 🌟 1. Check Auth State and Username
  const token = localStorage.getItem('authToken');
  const username = localStorage.getItem('userName') || 'User';
  const isLoggedIn = !!token;
  
  // 🌟 2. Handle Logout Function
  // 🌟 Fixed Handle Logout Function
const handleLogout = () => {
  // 1. Clear targeted keys explicitly
  localStorage.removeItem('authToken');
  localStorage.removeItem('userName');
  localStorage.removeItem('subscriptionTier');
  localStorage.removeItem('isSubscriptionActive');
  localStorage.removeItem('expiryDate');
  localStorage.removeItem('ID');

  // 2. Clear remaining local storage items
  localStorage.clear();

  // 3. Navigate or Hard Reload safely
  navigate('/', { replace: true });
  window.location.reload();
};
     
  const [showSearch, setShowSearch] = useState(false);
  const [visible, setVisible] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const checkScroll = () => {
      if (!showScrollTop && window.pageYOffset > 400) {
        setShowScrollTop(true);
      } else if (showScrollTop && window.pageYOffset <= 400) {
        setShowScrollTop(false);
      }
    };

    window.addEventListener('scroll', checkScroll);
    return () => window.removeEventListener('scroll', checkScroll);
  }, [showScrollTop]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div style={{ position: 'relative' }}>
      {/* Function 6: Search Bar Overlay with Blur */}
      {showSearch && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
          backgroundColor: 'rgba(255,255,255,0.8)', backdropFilter: 'blur(10px)',
          zIndex: 2000, display: 'flex', justifyContent: 'center', alignItems: 'center'
        }}>
          <div className="w-50 text-center">
            <CFormInput size="lg" placeholder="Search content/keyword..." className="mb-3 shadow" />
            <CButton color="danger" onClick={() => setShowSearch(false)}>Close Search</CButton>
          </div>
        </div>
      )}

      {/* Function 9: Fixed Header & Menu */}
      <CHeader position="sticky" className="p-0 border-0 shadow-sm bg-white" style={{ zIndex: 1000 }}>
        <CContainer> 
          <div className="d-flex align-items-center justify-content-between w-100 py-2">
            
            {/* Logo Section */}
            <CHeaderBrand onClick={() => navigate('/')} style={{ cursor: 'pointer' }} className="m-0">
              <img src={logo} alt="AMBIPI" style={{ height: '45px' }} />
            </CHeaderBrand>

            {/* Desktop Menu */}
            <CHeaderNav className="d-none d-lg-flex align-items-center gap-4">
             <CDropdown variant="nav-item">
  <CDropdownToggle 
    className="fw-bold border-0 bg-transparent text-dark shadow-none" 
    style={{ cursor: 'pointer' }}
  >
    Courses
  </CDropdownToggle>
  <CDropdownMenu>
    {['Alpha', 'Beeta', 'Gamma', 'Delta', 'Sigma'].map(item => (
      <CDropdownItem 
        key={item} 
        style={{ cursor: 'pointer' }}
        onClick={() => navigate(`/course/${item.toLowerCase()}`)}
      >
        {item}
      </CDropdownItem>
    ))}
  </CDropdownMenu>
</CDropdown>

              <CNavLink href="/about" className="fw-bold text-dark">About Us</CNavLink>
              <CNavLink href="/contact" className="fw-bold text-dark">Contact Us</CNavLink>

              {/* Desktop Icons Group */}
              <div className="d-flex align-items-center gap-3 ms-2">
                {isLoggedIn ? (
                  <>
                    <span className="text-dark fw-bold" style={{ cursor: 'pointer' }} onClick={()=>navigate('/profile')}>
                      Hi, <span className="text-primary">{username}</span>  
                    </span>
                    <CButton 
                      color="danger" 
                      size="sm" 
                      variant="outline"
                      onClick={handleLogout}
                      style={{ borderRadius: '5px' }}
                    >
                      Logout
                    </CButton>
                  </>
                ) : (
                  <>
                    <CButton 
                      color="primary" 
                      size="sm" 
                      variant="outline"
                      onClick={() => navigate('/login')}
                    >
                      Login
                    </CButton>
                    <CButton 
                      color="dark" 
                      size="sm" 
                      onClick={() => navigate('/register')}
                    >
                      Register
                    </CButton>
                  </>
                )}

                <div onClick={() => setShowSearch(true)} style={{ cursor: 'pointer' }}>
                  <CIcon icon={cilSearch} size="lg" className="text-dark" />
                </div>
              </div>
            </CHeaderNav>
            <div style={{ position: 'fixed', top: '60px', left: 0, width: '100%', zIndex: 999 }}>
  <AnnouncementBanner position="below-top-menu" />
  
</div>

            {/* Mobile Toggler */}
            <CHeaderToggler className="d-lg-none" onClick={() => setVisible(!visible)}>
              <CIcon icon={cilMenu} size="lg" />
            </CHeaderToggler>
          </div>

          {/* Mobile Menu Collapse */}
          <CCollapse visible={visible} className="d-lg-none border-top mt-2">
            <CHeaderNav className="flex-column p-3">
              
              {/* Courses Dropdown for Mobile */}
              <CDropdown variant="nav-item" className="py-2">
                <CDropdownToggle className="fw-bold text-dark p-0 border-0 bg-transparent">
                  Courses
                </CDropdownToggle>
                <CDropdownMenu className="border-0 shadow-none ps-3">
                  {['Alpha', 'Beeta', 'Gamma', 'Delta', 'Sigma'].map(item => (
                    <CDropdownItem 
                      key={item} 
                      onClick={() => { navigate(`/course/${item.toLowerCase()}`); setVisible(false); }}
                      className="py-2"
                    >
                      {item}
                    </CDropdownItem>
                  ))}
                </CDropdownMenu>
              </CDropdown>

              {/* Regular Links */}
              <CNavLink 
                href="/about" 
                className="fw-bold text-dark py-3 border-top"
                onClick={() => setVisible(false)}
              >
                About Us
              </CNavLink>
              
              <CNavLink 
                href="/contact" 
                className="fw-bold text-dark py-3 border-top"
                onClick={() => setVisible(false)}
              >
                Contact Us
              </CNavLink>

              {/* 🌟 Icons & Auth Section for Mobile View */}
              <div className="d-flex align-items-center gap-4 py-3 border-top mt-2">
                <CDropdown variant="nav-item">
                  <CDropdownToggle className="p-0 border-0 bg-transparent shadow-none">
                    <div className="d-flex align-items-center gap-2">
                      <CIcon icon={cilUser} size="lg" className="text-dark" />
                      {/* 🔥 Dynamic Username/Account Text for Mobile */}
                      <span className="fw-bold text-dark">
                        {isLoggedIn ? username : 'Account'}
                      </span>
                    </div>
                  </CDropdownToggle>
                  <CDropdownMenu>
                    {/* 🔥 Condition Based Menu Items for Mobile */}
                    {!isLoggedIn ? (
                      <>
                        <CDropdownItem onClick={() => { navigate('/login'); setVisible(false); }}>
                          Login
                        </CDropdownItem>
                        <CDropdownItem onClick={() => { navigate('/register'); setVisible(false); }}>
                          Registration
                        </CDropdownItem>
                      </>
                    ) : (
                      <CDropdownItem 
                        onClick={() => { handleLogout(); setVisible(false); }} 
                        className="text-danger fw-bold"
                      >
                        Logout
                      </CDropdownItem>
                    )}
                  </CDropdownMenu>
                </CDropdown>

                <div 
                  onClick={() => { setShowSearch(true); setVisible(false); }} 
                  className="d-flex align-items-center gap-2"
                  style={{ cursor: 'pointer' }}
                >
                  <CIcon icon={cilSearch} size="lg" className="text-dark" />
                  <span className="fw-bold text-dark">Search</span>
                </div>
              </div>

            </CHeaderNav>
          </CCollapse>
        </CContainer>
      </CHeader>

      {/* Main Content */}
      <main><Outlet /></main>

      {/* Styled Footer with Light Background */}
      <footer className="pt-5 pb-4 border-top mt-5" style={{ backgroundColor: '#f8f9fa' }}>
        <CContainer>
          <CRow>
            {/* Column 1: Logo & Brief */}
            <CCol lg={3} md={6} className="mb-4">
              <div className="bg-white p-2 d-inline-block rounded mb-3 shadow-sm">
                <img src={logo} alt="AMBIPI Logo" style={{ height: '40px' }} />
              </div>
              <div className="border-top border-danger pt-3 mt-2" style={{ borderTopWidth: '3px !important' }}>
                <p className="small text-dark fw-bold mb-1">AMBIPI (एम्बीपाई)</p>
                <p className="small text-muted" style={{ lineHeight: '1.6' }}>
                  is started by Amans Maths Blogs. Here, you will get the competitive exams PYQs, 
                  TextBooks Solutions and Some Important Notes.
                </p>
              </div>
            </CCol>

            {/* Column 2: Main Menu */}
            <CCol lg={3} md={6} className="mb-4 ps-lg-5">
              <h5 className="fw-bold mb-4 text-dark" style={{ fontSize: '1.1rem' }}>Main Menu</h5>
              <ul className="list-unstyled">
                {['Home', 'Alpha', 'Beeta', 'Gamma', 'Delta', 'Sigma'].map((item) => (
                  <li key={item} className="mb-2">
                    <CNavLink 
                      onClick={() => navigate(item === 'Home' ? '/' : `/course/${item.toLowerCase()}`)}
                      className="p-0 text-muted small hover-link" 
                      style={{ cursor: 'pointer', transition: '0.2s' }}
                    >
                      {item}
                    </CNavLink>
                  </li>
                ))}
              </ul>
            </CCol>

            {/* Column 3: Quick Links */}
            <CCol lg={3} md={6} className="mb-4">
              <h5 className="fw-bold mb-4 text-dark" style={{ fontSize: '1.1rem' }}>Quick Links</h5>
              <ul className="list-unstyled">
                {['About Us', 'Contact Us', 'Privacy Policy', 'Terms & Conditions'].map((link) => (
                  <li key={link} className="mb-2">
                    <CNavLink href="#" className="p-0 text-muted small">{link}</CNavLink>
                  </li>
                ))}
              </ul>
            </CCol>

            {/* Column 4: Contact Details */}
            <CCol lg={3} md={6} className="mb-4">
              <h5 className="fw-bold mb-4 text-dark" style={{ fontSize: '1.1rem' }}>Contact Details</h5>
              <div className="text-muted small">
                <p className="mb-3 d-flex align-items-center">
                  <span className="me-2">📧</span> support@ambipi.com
                </p>
                <p className="mb-3 d-flex align-items-start">
                  <span className="me-2">📍</span> Varanasi, Uttar Pradesh, India
                </p>
              </div>
            </CCol>
          </CRow>

          {/* Copyright Bar */}
          <div className="border-top pt-4 mt-2 text-center">
            <p className="small text-muted mb-0">
              &copy; {new Date().getFullYear()} <strong>AMBIPI</strong>. All rights reserved.
            </p>
            <AnnouncementBanner position="below-footer" />
          </div>
        </CContainer>
      </footer>

      {/* Scroll to Top Button */}
      {showScrollTop && (
        <CButton
          onClick={scrollToTop}
          color="primary"
          className="position-fixed shadow-lg d-flex align-items-center justify-content-center"
          style={{
            bottom: '40px',
            right: '40px',
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            zIndex: '1000',
            fontSize: '20px',
            transition: 'all 0.3s ease-in-out',
            backgroundColor: '#002147',
            border: '2px solid white'
          }}
        >
          ↑
        </CButton>
      )}
    </div>
  );
};

export default MembershipLayout;